// extracted by mini-css-extract-plugin
module.exports = {"instructions":"Instructions_instructions__2nNEj","endButton":"Instructions_endButton__tBn37","pointer":"Instructions_pointer__3KnER"};